import {PortsChunk} from "../../chunks/types/PortsChunk";

export function getDirectionFromPortsChunk(
  portsChunk: PortsChunk
): string {
  const {
    captures: {
      1: portsDirectionChunk
    }
  } = portsChunk;
  return portsDirectionChunk.captures[0];
}
